import React, { useState } from "react"
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap"
import { MdHelpOutline, MdOutlinePrint } from "react-icons/md"
import IconoCohorte from "./IconoCohorte"
import Tour from "reactour"
import SplashTour from "../Tutoriales/SplashTour"
import SplashTourEnd from "../Tutoriales/SplashTourEnd"
import tutoriales from "../Tutoriales/Tutoriales"
import log from "loglevel"

const TituloVista = (props) => {
  const [tourOpen, setTourOpen] = useState(false)

  const closeTour = () => {
    setTourOpen(false)
  }

log.debug(props.vista)

return (<>
    {props.vista && props.vista.tour && (
      <Tour
        steps={[
          {
            selector: "",
            content: <SplashTour titulo={tutoriales[props.vista.tour].title} />,
          },
          ...tutoriales[props.vista.tour].steps,
          {
            selector: "",
            content: <SplashTourEnd titulo={tutoriales[props.vista.tour].title} />,
          },
        ]}
        isOpen={tourOpen}
        onRequestClose={closeTour}
        lastStepNextButton={<Button>Terminar</Button>}
        disableFocusLock={true}
        className="tourContainer"
      />
    )}
    <h4 className="titulo-vista">
      <IconoCohorte background={true} />
      &nbsp;{props.title}
      {props.vista && props.vista.tour && (
          <OverlayTrigger overlay={<Tooltip>Ayuda de la página</Tooltip>}>
            <span className="abrir-tour">
              <MdHelpOutline
                className="icono-tour"
                id="icono-tour"
                onClick={() => {
                  setTourOpen(true)
                }}
              />
            </span>
          </OverlayTrigger>
        )}
      <div className="float-end">
        {props.botones}
        {props.imprimir && (
          <Button
            variant="outline-primary"
            onClick={() => {
              window.print()
            }}
            title="Imprimir"
          >
            <MdOutlinePrint />
          </Button>
        )}
      </div>
    </h4>
    </>)
}

export default TituloVista
